/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GatewayNumberType {
    TEST = 'Test',
    TYPE1000 = 'Type1000',
    TYPE2000 = 'Type2000',
    TYPE3000 = 'Type3000',
}
